<h3 mat-dialog-title>{{ 'Manage Widgets' }}</h3>

<mat-dialog-content class="has-table">
    <p class="text-secondary text-center m-3">
        {{ 'Drag and drop item in list to reorder widgets.' }}
    </p>

    <app-drop-list [items]="allWidgets">
        <ng-template let-item #dropList>
            <mat-slide-toggle class="my-auto"
                              [(ngModel)]="item.isEnabled"
                              (change)="storeInitial(item, $event)">
                <label>{{ 'Visible' }}</label>
            </mat-slide-toggle>
        </ng-template>
    </app-drop-list>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="btn btn-outline-secondary"
            [disabled]="isSaving"
            (click)="cancelUpdate()">
        {{ 'Cancel' }}
    </button>
    <div class="btn-group btn-save-container">
        <button class="btn btn-outline-secondary disabled"
                [class.hidden]="!isSaving">
            <i class="fa fa-spinner fa-pulse"></i> {{ 'Saving' }}&hellip;
        </button>
        <button class="btn btn-primary"
                [disabled]="isSaving"
                (click)="updateDashboardWidgets()">{{ 'Update' }}</button>
    </div>
</mat-dialog-actions>
